import Chapter1Lesson1 from './chapter1/lesson1.vue'
import Chapter1Lesson2 from './chapter1/lesson2.vue'
import Chapter1Lesson3 from './chapter1/lesson3.vue'
import Chapter1Lesson4 from './chapter1/lesson4.vue'
import Chapter2Lesson1 from './chapter2/lesson1.vue'
import Chapter2Lesson2 from './chapter2/lesson2.vue'

export const chapters = [
  {
    id: 1,
    title: 'Setting up the developer machine',
    lessons: [
      {
        id: 1,
        title: 'Homebrew',
        component: Chapter1Lesson1
      },
      {
        id: 2,
        title: 'AWS CLI',
        component: Chapter1Lesson2
      },
      {
        id: 3,
        title: 'Terraform',
        component: Chapter1Lesson3
      },
      {
        id: 4,
        title: 'Git',
        component: Chapter1Lesson4
      }
    ]
  },
  {
    id: 2,
    title: 'Advanced Features',
    lessons: [
      {
        id: 1,
        title: 'Advanced Monitoring Features',
        component: Chapter2Lesson1
      },
      {
        id: 2,
        title: 'CI/CD Pipeline Integration',
        component: Chapter2Lesson2
      }
    ]
  }
]

export function getChapter(chapterId) {
  return chapters.find(chapter => chapter.id === chapterId)
}

export function getLesson(chapterId, lessonId) {
  const chapter = getChapter(chapterId)
  if (!chapter) return null
  return chapter.lessons.find(lesson => lesson.id === lessonId)
}

export function getNextLesson(chapterId, lessonId) {
  const chapter = getChapter(chapterId)
  if (!chapter) return null

  const currentLessonIndex = chapter.lessons.findIndex(lesson => lesson.id === lessonId)
  if (currentLessonIndex === -1) return null

  // If there's another lesson in the current chapter
  if (currentLessonIndex < chapter.lessons.length - 1) {
    return {
      chapterId,
      lessonId: chapter.lessons[currentLessonIndex + 1].id
    }
  }

  // If there's another chapter
  const nextChapterIndex = chapters.findIndex(c => c.id === chapterId) + 1
  if (nextChapterIndex < chapters.length) {
    return {
      chapterId: chapters[nextChapterIndex].id,
      lessonId: chapters[nextChapterIndex].lessons[0].id
    }
  }

  return null
}

export function getPreviousLesson(chapterId, lessonId) {
  const chapter = getChapter(chapterId)
  if (!chapter) return null

  const currentLessonIndex = chapter.lessons.findIndex(lesson => lesson.id === lessonId)
  if (currentLessonIndex === -1) return null

  // If there's a previous lesson in the current chapter
  if (currentLessonIndex > 0) {
    return {
      chapterId,
      lessonId: chapter.lessons[currentLessonIndex - 1].id
    }
  }

  // If there's a previous chapter
  const prevChapterIndex = chapters.findIndex(c => c.id === chapterId) - 1
  if (prevChapterIndex >= 0) {
    const prevChapter = chapters[prevChapterIndex]
    return {
      chapterId: prevChapter.id,
      lessonId: prevChapter.lessons[prevChapter.lessons.length - 1].id
    }
  }

  return null
} 